module.exports = __webpack_public_path__ + "img/22logo(Black)@3x.c4cb37c9.png";